import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-bg-main py-12 md:py-20 px-4" data-id="element-36">
      <div className="max-w-6xl mx-auto" data-id="element-37">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-38">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-39">
            <div className="inline-flex items-center gap-2 bg-white/60 px-4 py-2 rounded-full border border-primary/20 shadow-sm" data-id="element-40">
              <span className="flex h-2 w-2 rounded-full bg-accent" data-id="element-41"></span>
              <span className="text-sm font-medium text-text-secondary" data-id="element-42">
                +1,200 mujeres en Colombia ya están entendiendo su ciclo
              </span>
            </div>

            <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-text-primary leading-tight" data-id="element-43">
              No eres inconsistente…{' '}
              <span className="text-accent" data-id="element-44">eres cíclica.</span> Y eso cambia
              todo.
            </h1>

            <motion.a href="#comprar" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-primary text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:bg-accent transition-colors" data-id="element-45">
              Descargar guía ahora
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/oBf9CxMtrJgFHczKmntrb1/ChatGPT_Image_18_abr_2026,_11_02_06.png" alt="Guía Ciclo Consciente" className="w-full max-w-md drop-shadow-2xl" data-id="element-47" />
          </motion.div>
        </div>
      </div>
    </section>;
}